/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentPayParcelViewModel } from "../types/IndividualPaymentPayParcelViewModel.ts";

export const individualPaymentPayParcelViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  totalPaid: z.number().nullish(),
  paymentDate: z.string().datetime().nullish(),
  paymentMethod: z.optional(z.number().int()),
  totalDiscount: z.number().nullish(),
  retroactiveDiscount: z.number().nullish(),
  fine: z.number().nullish(),
  discountPunctualPercentage: z.number().nullish(),
  lastTransactionNumber: z.string().nullish(),
  billetIntegrationFealq: z.optional(z.boolean()),
}) as unknown as ToZod<IndividualPaymentPayParcelViewModel>;
